var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const Svg2Tabla = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "12px",
    viewBox: "0 0 15 12",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Salida-datos",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "inicio-selecci\\xF3n-multiple-de-eventos-copy-15",
    transform: "translate(-1249.000000, -143.000000)",
    fill: "#525252"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1249.000000, 143.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.2,4.8 C0.536,4.8 0,5.336 0,6 C0,6.664 0.536,7.2 1.2,7.2 C1.864,7.2 2.4,6.664 2.4,6 C2.4,5.336 1.864,4.8 1.2,4.8 L1.2,4.8 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.2,0 C0.536,0 0,0.536 0,1.2 C0,1.864 0.536,2.4 1.2,2.4 C1.864,2.4 2.4,1.864 2.4,1.2 C2.4,0.536 1.864,0 1.2,0 L1.2,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.2,9.736 C0.608,9.736 0.136,10.216 0.136,10.8 C0.136,11.384 0.616,11.864 1.2,11.864 C1.784,11.864 2.264,11.384 2.264,10.8 C2.264,10.216 1.792,9.736 1.2,9.736 L1.2,9.736 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "3.6 11.6 14.8 11.6 14.8 10 3.6 10"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "3.6 6.8 14.8 6.8 14.8 5.2 3.6 5.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "3.6 0.4 3.6 2 14.8 2 14.8 0.4"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg2Tabla, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/2_Tabla.b663cda8.svg";
export { ForwardRef as ReactComponent };